import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { BtnArrowRightStyled } from "./styled";
import { Icons } from "components";

const BtnArrowRight = ({
  theme_standard,
  theme_text_center,
  type = "button",
  label,
  onClick,
  disabled,
  bgColor,
  txtColor,
  height,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
    theme_text_center: theme_text_center,
  });
  return (
    <BtnArrowRightStyled
      disabled={disabled}
      bgColor={bgColor}
      txtColor={txtColor}
      height={height}
    >
      <div className={customClass}>
        <button
          type={type}
          disabled={disabled}
          className="btn_arrow_right"
          onClick={onClick}
        >
          <div className="label">{label}</div>
          <Icons.ArrowRightCircle2 color={"#FFFFFF"} />
        </button>
      </div>
    </BtnArrowRightStyled>
  );
};

BtnArrowRight.propTypes = {};

export default BtnArrowRight;
